module.exports = __webpack_public_path__ + "static/media/manila-gray.762af896.svg";